var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"quantity-display"},[_c('span',{staticClass:"quantity-value"},[_vm._v(_vm._s(_vm.formattedValue))]),(_vm.unit)?_c('span',{staticClass:"quantity-unit"},[_vm._v(_vm._s(_vm.unit))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }